module.exports = __webpack_public_path__ + "static/media/avatar.b3323322.png";